"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pages = exports.pageUI = exports.pageMarkdown = exports.pageHTML = exports.pageEditorState = exports.page = exports.isLoading = exports.draftOrPublishedPage = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reselect = require("reselect");
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var assetsSelectors = _interopRequireWildcard(require("../assets/selectors"));
var portalsSelectors = _interopRequireWildcard(require("../portals/selectors"));
var _utils = require("./utils");
var _assets = require("../../utils/assets");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var DEFAULT_PAGE_NAME = 'home';
function getPortalKey(_ref) {
  var groupId = _ref.groupId,
    assetId = _ref.assetId,
    version = _ref.version,
    isDraft = _ref.isDraft;
  return "".concat(groupId, "/").concat(assetId, "/").concat((0, _assets.getMinorVersion)(version)).concat(isDraft ? '/draft' : '');
}
var isLoading = exports.isLoading = function isLoading(state) {
  return state.pages.ui.isLoading;
};
var memoizedPageParams = (0, _memoizeOne.default)(function (groupId, assetId, isDraft) {
  return {
    groupId: groupId,
    assetId: assetId,
    isDraft: isDraft
  };
});
var pageParams = (0, _reselect.createSelector)(assetsSelectors.version, function (state, props) {
  var _props$isDraft;
  return memoizedPageParams(props.groupId, props.assetId, (_props$isDraft = props.isDraft) !== null && _props$isDraft !== void 0 ? _props$isDraft : false);
}, function (version, $props) {
  return _objectSpread(_objectSpread({}, $props), {}, {
    version: version
  });
});
var pagesMap = (0, _reselect.createSelector)(pageParams, function (state) {
  return state.pages.data;
}, function ($params, $pages) {
  return $params.version ? $pages[getPortalKey($params)] : null;
});
var pagesList = (0, _reselect.createSelector)(portalsSelectors.portal, pagesMap, function ($portal, $pages) {
  var _$portal$pages;
  return $portal && $pages ? (_$portal$pages = $portal.pages) === null || _$portal$pages === void 0 ? void 0 : _$portal$pages.map(function (portalPage) {
    return $pages[portalPage.path];
  }) : null;
});
function getPageProp(pagesHashMap, pagePath, prop) {
  var _pagesHashMap$pagePat, _pagesHashMap$pagePat2;
  return (_pagesHashMap$pagePat = pagesHashMap === null || pagesHashMap === void 0 || (_pagesHashMap$pagePat2 = pagesHashMap[pagePath]) === null || _pagesHashMap$pagePat2 === void 0 ? void 0 : _pagesHashMap$pagePat2[prop]) !== null && _pagesHashMap$pagePat !== void 0 ? _pagesHashMap$pagePat : null;
}
var emptyPage = {};
var page = exports.page = (0, _reselect.createSelector)(pagesMap, function (state, props) {
  return props.pagePath || DEFAULT_PAGE_NAME;
}, function ($pages, $pagePath) {
  return $pages ? $pages[$pagePath] : emptyPage;
});
var pages = exports.pages = (0, _reselect.createSelector)(pagesList, function ($pagesList) {
  return $pagesList === null || $pagesList === void 0 ? void 0 : $pagesList.filter(function ($page) {
    return $page && !$page.isRenamed;
  });
});
var pageHTML = exports.pageHTML = (0, _reselect.createSelector)(pagesMap, function (state, props) {
  return props.pagePath;
}, function ($map, $pagePath) {
  return getPageProp($map, $pagePath, 'html');
});
var pageMarkdown = exports.pageMarkdown = (0, _reselect.createSelector)(pagesMap, function (state, props) {
  return props.pagePath;
}, function ($map, $pagePath) {
  return getPageProp($map, $pagePath, 'markdown');
});
var pageUI = exports.pageUI = function pageUI(state) {
  return state.pages.ui;
};
var memoizedEmptyPage = (0, _memoizeOne.default)(function (pagePath) {
  return {
    name: pagePath,
    path: pagePath,
    html: '',
    markdown: ''
  };
});
var draftOrPublishedPage = exports.draftOrPublishedPage = function draftOrPublishedPage(state, params) {
  var draftPage = page(state, _objectSpread(_objectSpread({}, params), {}, {
    isDraft: true
  }));
  if (draftPage !== null && draftPage !== void 0 && draftPage.path) {
    return draftPage;
  }
  var publishedPage = page(state, _objectSpread(_objectSpread({}, params), {}, {
    isDraft: false
  }));
  if (publishedPage !== null && publishedPage !== void 0 && publishedPage.path) {
    return publishedPage;
  }
  return memoizedEmptyPage(params.pagePath);
};
var pageEditorState = exports.pageEditorState = (0, _reselect.createSelector)(pageParams, pageUI, draftOrPublishedPage, function (params, ui, $page) {
  if ($page.path === ui.pageEditorState.pagePath && ui.pageEditorState.hasUnsavedChanges) {
    return ui.pageEditorState;
  }
  return {
    hasUnsavedChanges: false,
    groupId: params.groupId,
    assetId: params.assetId,
    version: params.version,
    pageContent: $page.markdown,
    pagePath: $page.path,
    pageName: (0, _utils.getPredefinedPageName)($page.name)
  };
});
//# sourceMappingURL=selectors.js.map